module.exports = __webpack_public_path__ + "img/cart.5e23b458.svg";